import { QueryClient } from "@tanstack/react-query";
import { getAuthToken } from "./authAdmin";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://api.resto-online.be";
//const BACKEND = "http://localhost:6969";
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
        },
    },
});
export async function loginAdmin({ email, password }) {
    const response = await fetch(`${BACKEND}/admin/auth/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
    });


    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het inloggen.");
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return await response.json();
}

export async function signupAdmin({ email, password, name }) {
    const response = await fetch(`${BACKEND}/admin/auth/signup`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password, name }),
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het registreren.");
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return await response.json();
}
export const addProduct = async (productData) => {
    const token = getAuthToken();

    try {
        console.log(`Sending POST request to ${BACKEND}/admin/products`);
        
        // Set proper headers for multipart/form-data
        const headers = {
            Authorization: `Bearer ${token}`
        };
        
        // Create fetch options
        const options = {
            method: "POST",
            headers,
            body: productData,
        };
        
        // Execute the request with timeout of 60 seconds
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 60000);
        
        const response = await fetch(`${BACKEND}/admin/products`, {
            ...options,
            signal: controller.signal
        });
        
        clearTimeout(timeoutId);
        
        // Log response details for debugging
        console.log(`Response status: ${response.status} (${response.statusText})`);
        
        if (!response.ok) {
            // Special handling for 413 Request Entity Too Large
            if (response.status === 413) {
                throw new Error(
                    "De afbeelding is te groot. Probeer een kleinere of meer gecomprimeerde afbeelding te uploaden."
                );
            }
            
            const errorData = await response.json().catch(() => ({}));
            console.error("Error response data:", errorData);
            
            const error = new Error(
                errorData.message || "Er is iets misgegaan tijdens het toevoegen van een product."
            );
            error.code = response.status;
            error.info = errorData;
            throw error;
        }
        
        return await response.json();
    } catch (error) {
        console.error("Error in addProduct:", error);
        if (error.name === 'AbortError') {
            throw new Error("De aanvraag heeft te lang geduurd en is afgebroken. Probeer een kleinere afbeelding.");
        }
        throw error;
    }
};

export const updateProduct = async (productData) => {
    const token = getAuthToken();

    // Extract ID from FormData or object
    let id;
    if (productData instanceof FormData) {
        id = productData.get('_id');
        // Remove _id from FormData to avoid duplicate in URL
        productData.delete('_id');
    } else {
        id = productData._id;
    }

    if (!id) {
        throw new Error("Product ID ontbreekt. Kan geen update uitvoeren.");
    }

    try {
        console.log(`Sending PUT request to ${BACKEND}/admin/products/${id}`);
        
        // Set proper headers for multipart/form-data
        const headers = {
            Authorization: `Bearer ${token}`
        };
        
        // Create fetch options
        const options = {
            method: "PUT",
            headers,
            body: productData,
        };
        
        // Execute the request with timeout of 60 seconds
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 60000);
        
        const response = await fetch(`${BACKEND}/admin/products/${id}`, {
            ...options,
            signal: controller.signal
        });
        
        clearTimeout(timeoutId);
        
        // Log response details for debugging
        console.log(`Response status: ${response.status} (${response.statusText})`);
        
        if (!response.ok) {
            // Special handling for 413 Request Entity Too Large
            if (response.status === 413) {
                throw new Error(
                    "De afbeelding is te groot. Probeer een kleinere of meer gecomprimeerde afbeelding te uploaden."
                );
            }
            
            const errorData = await response.json().catch(() => ({}));
            console.error("Error response data:", errorData);
            
            const error = new Error(
                errorData.message || "Er is iets misgegaan tijdens het bijwerken van het product."
            );
            error.code = response.status;
            error.info = errorData;
            throw error;
        }
        
        return await response.json();
    } catch (error) {
        console.error("Error in updateProduct:", error);
        if (error.name === 'AbortError') {
            throw new Error("De aanvraag heeft te lang geduurd en is afgebroken. Probeer een kleinere afbeelding.");
        }
        throw error;
    }
};

export const deleteProduct = async (productId) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    if (!productId) {
        throw new Error("Product ID ontbreekt. Kan geen verwijdering uitvoeren.");
    }

    const response = await fetch(
        `${BACKEND}/admin/products/${productId}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
    }
    );

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het verwijderen van het product."
        );
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return response.json();
};

export const fetchProducts = async ({ signal }) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.
    const response = await fetch(`${BACKEND}/admin/products`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het ophalen van de producten."
        );
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const fetchCollections = async ({ signal }) => {
    const token = getAuthToken();
    const response = await fetch(`${BACKEND}/admin/collections`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het ophalen van de collecties.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const addMenu = async (menuData) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    const response = await fetch(`${BACKEND}/admin/menus`, {
        method: "POST",
        headers: {
            // "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
        body: menuData,
    });

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het toevoegen van een menu."
        );
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return response.json();
};

export const updateMenu = async (menuData) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    // Haal het ID uit de FormData of object
    const id = menuData instanceof FormData ? menuData.get('_id') : menuData._id;

    if (!id) {
        throw new Error("Menu ID ontbreekt. Kan geen update uitvoeren.");
    }

    const response = await fetch(
        `${BACKEND}/admin/menus/${id}`, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
        body: menuData,
    }
    );

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het bijwerken van het menu."
        );
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return response.json();
};

export const deleteMenu = async (menuId) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    if (!menuId) {
        throw new Error("Menu ID ontbreekt. Kan geen verwijdering uitvoeren.");
    }

    const response = await fetch(`${BACKEND}/admin/menus/${menuId}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
    });

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het verwijderen van het menu."
        );
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return response.json();
};

export const fetchMenus = async ({ signal }) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.
    const response = await fetch(`${BACKEND}/admin/menus`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het ophalen van de menu's."
        );
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const fetchAccountSettings = async () => {
    const token = getAuthToken();
    const response = await fetch(
        `${BACKEND}/admin/account/settings`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }
    );

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het ophalen van de accountinstellingen."
        );
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const updateAccountSettings = async (settingsData) => {
    const token = getAuthToken();

    const response = await fetch(
        `${BACKEND}/admin/account/settings`, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        body: settingsData,
    }
    );

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het bijwerken van de accountinstellingen."
        );
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const fetchPickupMoments = async ({ signal }) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    const response = await fetch(`${BACKEND}/admin/pickup-moments`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
        signal, // Optioneel: Voeg de signal toe voor het annuleren van requests.
    });

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het ophalen van de ophaalmomenten."
        );
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json(); // Geef de JSON-response terug.
};

export const updatePickupSlots = async (slots, day) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    if (!slots) {
        throw new Error("Geen pickup slot data ontvangen.");
    }

    // Add the day to the data being sent
    const dataToSend = { day, slots }; // Include the day in the data object.
    const response = await fetch(`${BACKEND}/admin/pickup-moments`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
        body: JSON.stringify(dataToSend),
    });

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het bijwerken van de pickup slots."
        );
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return response.json(); // Return de response als het bijwerken succesvol is.
};

export const fetchOpeningHours = async ({ signal }) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    const response = await fetch(`${BACKEND}/admin/opening-hours`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
        signal, // Optioneel: Voeg de signal toe voor het annuleren van requests.
    });

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het ophalen van de openingsuren."
        );
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json(); // Geef de JSON-response terug.
};

export const updateOpeningHours = async (slots, day) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    if (!slots) {
        throw new Error("Geen pickup slot data ontvangen.");
    }

    // Add the day to the data being sent
    const dataToSend = { day, slots }; // Include the day in the data object.
    const response = await fetch(`${BACKEND}/admin/opening-hours`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
        body: JSON.stringify(dataToSend),
    });

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het bijwerken van de openingsuren."
        );
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return response.json(); // Return de response als het bijwerken succesvol is.
};

export const updateVacationMode = async (vacationData) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.


    const response = await fetch(
        `${BACKEND}/admin/vacation-modes/${vacationData._id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
        body: JSON.stringify(vacationData),
    }
    );

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het bijwerken van de vakantie modus."
        );
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return response.json();
};

export const deleteVacationMode = async (vacationModeId) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    if (!vacationModeId) {
        throw new Error("Vakantiemodus ID ontbreekt. Kan geen verwijdering uitvoeren.");
    }

    const response = await fetch(
        `${BACKEND}/admin/vacation-modes/${vacationModeId}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
    }
    );

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het verwijderen van de vakantiemodus."
        );
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return response.json(); // Return de serverresponse als de verwijdering succesvol is.
};


export const fetchVacations = async () => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    const response = await fetch(
        `${BACKEND}/admin/vacation-modes`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
    }
    );

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het ophalen van de vakantiemodus."
        );
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return response.json();
};

// Voeg een nieuwe vakantieperiode toe
export const addVacationMode = async (vacationData) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    const response = await fetch(
        `${BACKEND}/admin/vacation-modes`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Voeg de token toe aan de Authorization-header.
        },
        body: JSON.stringify(vacationData),
    }
    );

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het toevoegen van de vakantiemodus."
        );
        error.code = response.status;
        error.info = await response.json();

        throw error;
    }

    return response.json();
};

export const addSubdomain = async ({ subdomain }) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    if (!subdomain) {
        throw new Error("Subdomein ontbreekt. Kan de webshop niet lanceren.");
    }

    const response = await fetch(`${BACKEND}/admin/stripe-connect/add-subdomain`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ subdomain }),
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het lanceren van de webshop.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const fetchOnboardingLink = async ({ signal }) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.
    const response = await fetch(`${BACKEND}/admin/stripe-connect/onboarding-link`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });

    if (!response.ok) {


        const error = new Error(
            "Er is iets misgegaan tijdens het ophalen van de onboardinglink."
        );
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const fetchStripeDashboardLink = async ({ signal }) => {
    const token = getAuthToken(); // Verkrijg de authenticatietoken.

    const response = await fetch(`${BACKEND}/admin/stripe-connect/dashboard-link`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error(
            "Er is iets misgegaan tijdens het ophalen van de Stripe Dashboard link."
        );
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};
export const fetchOrdersToday = async ({ signal }) => {
    const token = getAuthToken();
    const response = await fetch(`${BACKEND}/admin/orders/today`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Fout bij het ophalen van bestellingen voor vandaag.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const fetchOrdersFuture = async ({ signal }) => {
    const token = getAuthToken();
    const response = await fetch(`${BACKEND}/admin/orders/future`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Fout bij het ophalen van toekomstige bestellingen.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const fetchOrdersPast = async ({ signal }) => {
    const token = getAuthToken();
    const response = await fetch(`${BACKEND}/admin/orders/past`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });    
    if (!response.ok) {
        const error = new Error("Fout bij het ophalen van voorbije bestellingen.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const markOrderAsPickedUp = async (orderId) => {


    const token = getAuthToken();
    const response = await fetch(`${BACKEND}/admin/orders/${orderId}/mark-picked-up`, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ markedAsPickedUp: true }),
    });

    if (!response.ok) {
        const error = new Error("Fout bij het markeren van een bestelling als opgehaald.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};


export const addDiscount = async (discountData) => {
    const token = getAuthToken(); // Haal de authenticatietoken op

    const response = await fetch(`${BACKEND}/admin/discounts`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Voeg de token toe
        },
        body: JSON.stringify(discountData),
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het toevoegen van de korting.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const updateDiscount = async (discountData) => {
    const token = getAuthToken(); // Haal de authenticatietoken op

    const response = await fetch(`${BACKEND}/admin/discounts/${discountData._id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Voeg de token toe
        },
        body: JSON.stringify(discountData),
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het bijwerken van de korting.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};
export const fetchDiscounts = async ({ signal } = {}) => {
    const token = getAuthToken(); // Haal de authenticatietoken op

    const response = await fetch(`${BACKEND}/admin/discounts`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan bij het ophalen van de kortingen.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const deleteDiscount = async (discountId) => {
    const token = getAuthToken(); // Haal de authenticatietoken op

    const response = await fetch(`${BACKEND}/admin/discounts/${discountId}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan bij het verwijderen van de korting.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

// Collection functies
export const addCollection = async (data) => {
    const response = await fetch(`${BACKEND}/admin/collections`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAuthToken()}`,
        },
        body: JSON.stringify(data),
    });

    const responseData = await response.json();

    if (!response.ok) {
        throw {
            info: responseData,
            status: response.status,
        };
    }

    return responseData;
};

export const updateCollection = async (data) => {
    const response = await fetch(`${BACKEND}/admin/collections/${data._id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAuthToken()}`,
        },
        body: JSON.stringify(data),
    });

    const responseData = await response.json();

    if (!response.ok) {
        throw {
            info: responseData,
            status: response.status,
        };
    }

    return responseData;
};

export const deleteCollection = async (id) => {
    const response = await fetch(`${BACKEND}/admin/collections/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${getAuthToken()}`,
        },
    });

    const responseData = await response.json();

    if (!response.ok) {
        throw {
            info: responseData,
            status: response.status,
        };
    }

    return responseData;
};

export const updateCollectionSortOrder = async (data) => {
    const response = await fetch(`${BACKEND}/admin/collections/order/update`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAuthToken()}`,
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het bijwerken van de volgorde.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const fetchMonthlyRevenue = async ({ signal }) => {
    const token = getAuthToken();
    const response = await fetch(`${BACKEND}/admin/orders/revenue/monthly`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Fout bij het ophalen van de maandelijkse omzet.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const fetchRecentOrders = async ({ signal }) => {
    const token = getAuthToken();
    const response = await fetch(`${BACKEND}/admin/orders/recent`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Fout bij het ophalen van recente bestellingen.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};
